import AllRoutes from './AllRoutes';
import './App.css';
import Footer from './Footer';
import Navbar from './Navbar';

function App() {
  return (
    <div className="App">
     <Navbar/>
     <AllRoutes/>
     <Footer/>
    
         </div>
  );
}

export default App;
